import api from '@/api/fetchClient'

export default {
  getPayments(params = {}) {
    let url = 'payments'
    const queryParams = []

    if (params.search) {
      queryParams.push(`search=${encodeURIComponent(params.search)}`)
    }
    if (params.vendorId) {
      queryParams.push(`vendorId=${params.vendorId}`)
    }

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&')
    }

    return api.get(url, { authorized: true })
  },

  getPaymentById(id) {
    return api.get(`payments/${id}`, { authorized: true })
  },

  createPayment(payload) {
    return api.post('payments', payload, { authorized: true })
  },

  updatePayment(id, payload) {
    return api.put(`payments/${id}`, payload, { authorized: true })
  },

  deletePayment(id) {
    return api.delete(`payments/${id}`, { authorized: true })
  }
}
